import qs from "query-string";
import ccs from '../assets/ccs.json';

export function getUuid() {
  const { uuid } = qs.parse(window.location.search);

  return uuid;
}

export function getModel() {
  const { model } = qs.parse(window.location.search);
  const { version } = qs.parse(window.location.search);

  return { model, version };
}

export function getInterest() {
	const { interest } = qs.parse(window.location.search);

	return interest
}

export function distance(lat1, lon1, lat2, lon2, unit) {
	if ((lat1 === lat2) && (lon1 === lon2)) {
		return 0;
	}
	else {
		var radlat1 = Math.PI * lat1/180;
		var radlat2 = Math.PI * lat2/180;
		var theta = lon1-lon2;
		var radtheta = Math.PI * theta/180;
		var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
		if (dist > 1) {
			dist = 1;
		}
		dist = Math.acos(dist);
		dist = dist * 180/Math.PI;
		dist = dist * 60 * 1.1515;
		if (unit === "K") { dist = dist * 1.609344 }
		if (unit === "N") { dist = dist * 0.8684 }
		return dist;
	}
}

export function ccsRadius(location, radius) {
  if (location) {
		return ccs.map(concess => {
			const { latitude, longitude } = concess;
      const dist = distance(location.latitude, location.longitude, latitude, longitude, 'K');
			return { ...concess, dist };
		}).sort((c1, c2) => c1.dist - c2.dist).slice(0,3);
  }
}